var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.174 7.093V9.59h17.34V7.093H6.173zM6.174 11.297v2.496h8.013v-2.496H6.174zM16.288 0h-2.495v4.072h2.495V0zM16.288 22.462h-2.495v4.598h2.495v-4.598z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23.085l1.852-1.674 4.327 4.788-1.851 1.674-4.328-4.788zM14.524 23.085l-1.851-1.674L8.345 26.2l1.852 1.674 4.327-4.788zM6.174 15.5v2.496h11.165V15.5H6.174z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.212 23.153H8.46C3.795 23.153 0 19.358 0 14.693V1.97h25.378a4.84 4.84 0 014.834 4.834v16.349zM2.417 4.386v10.307a6.05 6.05 0 006.042 6.043h19.336V6.804a2.42 2.42 0 00-2.417-2.417L2.417 4.386z",
    fill: "#fff"
  })));
}
export default SvgBoard;